package com.macrofocus.eflux.ui.mui.utilities

import kotlinx.browser.window

val isMobile: Boolean get() = """(iPhone|iPad|Android)""".toRegex().matches(window.navigator.userAgent)
val isChrome: Boolean get() = """(Chrome)""".toRegex().matches(window.navigator.userAgent)
